import _ from 'lodash';
import gsap from 'gsap';
import { isHTMLElement } from './utils';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

const Home = {
  init() {
    const mv = document.querySelector('.home-mv');
    if (_.isElement(mv)) {
      moveitems();
      loading();
    }
    updateslider();
  },
};

// loading
const loading = (): void => {
  const copy_el = document.querySelector('.home-mv__copy');
  const bnr_el = document.querySelector('.home-mv__bnr');
  const layer1_el = document.querySelector('.home-mv__layer1');
  const layer2_el = document.querySelector('.home-mv__layer2');
  const layer3_el = document.querySelector('.home-mv__layer3');
  const layer4_el = document.querySelector('.home-mv__layer4');
  const layer5_el = document.querySelector('.home-mv__layer5');
  const layer6_el = document.querySelector('.home-mv__layer6');
  window.addEventListener('load', () => {
    let layer_diff = 0.3;
    let layer_delay = 1.5 - layer_diff;
    let layer_duration = 0.8;
    if (isHTMLElement(copy_el)) {
      gsap.to(copy_el, {
        autoAlpha: 1,
        duration: 0.8,
        delay: 0.5,
        ease: 'power1.out',
      });
    }
    if (isHTMLElement(layer6_el)) {
      layer_delay += layer_diff;
      gsap.to(layer6_el, {
        autoAlpha: 1,
        duration: layer_duration,
        delay: layer_delay,
        ease: 'power1.out',
      });
    }
    if (isHTMLElement(layer5_el)) {
      layer_delay += layer_diff;
      gsap.to(layer5_el, {
        autoAlpha: 1,
        duration: layer_duration,
        delay: layer_delay,
        ease: 'power1.out',
      });
    }
    if (isHTMLElement(layer4_el)) {
      layer_delay += layer_diff;
      gsap.to(layer4_el, {
        autoAlpha: 1,
        duration: layer_duration,
        delay: layer_delay,
        ease: 'power1.out',
      });
    }
    if (isHTMLElement(layer3_el)) {
      layer_delay += layer_diff;
      gsap.to(layer3_el, {
        autoAlpha: 1,
        duration: layer_duration,
        delay: layer_delay,
        ease: 'power1.out',
      });
    }
    if (isHTMLElement(layer2_el)) {
      layer_delay += layer_diff;
      gsap.to(layer2_el, {
        autoAlpha: 1,
        duration: layer_duration,
        delay: layer_delay,
        ease: 'power1.out',
      });
    }
    if (isHTMLElement(layer1_el)) {
      layer_delay += layer_diff;
      gsap.to(layer1_el, {
        autoAlpha: 1,
        duration: layer_duration,
        delay: layer_delay,
        ease: 'power1.out',
      });
    }
    if (isHTMLElement(bnr_el)) {
      layer_delay += layer_diff;
      gsap.to(bnr_el, {
        autoAlpha: 1,
        duration: layer_duration,
        delay: layer_delay,
        ease: 'power1.out',
      });
    }
  });
};

// moveitems
// const moveitems = (): void => {
//   const container = document.querySelector<HTMLElement>('.home-mv');
//   const items = document.querySelectorAll<HTMLElement>('[data-move]');
//   if (!container || items.length === 0) return;

//   // 各要素に対して quickSetter を作成
//   const setters = Array.from(items).map((item) => {
//     const moveAmountAttr = item.dataset.move;
//     const moveAmount = moveAmountAttr ? parseFloat(moveAmountAttr) : 20;

//     return {
//       x: gsap.quickTo(item, 'x', { duration: 0.3, ease: 'power3.out' }),
//       y: gsap.quickTo(item, 'y', { duration: 0.3, ease: 'power3.out' }),
//       moveAmount,
//     };
//   });

//   const handleMouseMove = (e: MouseEvent): void => {
//     const rect = container.getBoundingClientRect();
//     const x = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
//     const y = ((e.clientY - rect.top) / rect.height - 0.5) * 2;

//     setters.forEach(({ x: setX, y: setY, moveAmount }) => {
//       setX(Math.round(x * moveAmount));
//       setY(Math.round(y * moveAmount));
//     });
//   };

//   // throttleで頻度制御
//   const throttledMouseMove = _.throttle(handleMouseMove, 16);

//   container.addEventListener('mousemove', throttledMouseMove);
// };
const moveitems = (): void => {
  const container = document.querySelector<HTMLElement>('.home-mv');
  const items = document.querySelectorAll<HTMLElement>('[data-move]');
  if (!container || items.length === 0) return;

  // 各要素に対して quickSetter を作成
  const setters = Array.from(items).map((item) => {
    const moveAmountAttr = item.dataset.move;
    const moveAmount = moveAmountAttr ? parseFloat(moveAmountAttr) : 20;

    return {
      x: gsap.quickTo(item, 'x', { duration: 0.3, ease: 'power3.out' }),
      y: gsap.quickTo(item, 'y', { duration: 0.3, ease: 'power3.out' }),
      moveAmount,
    };
  });

  // マウスまたはタッチ位置を元に処理を行う共通関数
  const handleMove = (clientX: number, clientY: number): void => {
    const rect = container!.getBoundingClientRect();
    const x = ((clientX - rect.left) / rect.width - 0.5) * 2;
    const y = ((clientY - rect.top) / rect.height - 0.5) * 2;

    setters.forEach(({ x: setX, y: setY, moveAmount }) => {
      setX(Math.round(x * moveAmount));
      setY(Math.round(y * moveAmount));
    });
  };

  // イベントハンドラを統一
  const handleMouseMove = (e: MouseEvent) => {
    handleMove(e.clientX, e.clientY);
  };

  const handleTouchMove = (e: TouchEvent) => {
    if (e.touches.length > 0) {
      handleMove(e.touches[0].clientX, e.touches[0].clientY);
    }
  };

  // throttleで制御
  const throttledMouseMove = _.throttle(handleMouseMove, 16);
  const throttledTouchMove = _.throttle(handleTouchMove, 16);

  container.addEventListener('mousemove', throttledMouseMove);
  container.addEventListener('touchmove', throttledTouchMove, { passive: true }); // パフォーマンスのため passive:true を推奨
};

// updateslider
const updateslider = () => {
  const slider = document.querySelector('.home-update__slider .swiper') as HTMLElement;
  const prevEl = document.querySelector('.home-update__prev') as HTMLElement;
  const nextEl = document.querySelector('.home-update__next') as HTMLElement;
  if (_.isElement(slider) && _.isElement(prevEl) && _.isElement(nextEl)) {
    new Swiper(slider, {
      modules: [Navigation],
      loop: true,
      navigation: {
        prevEl,
        nextEl,
      },
    });
  }
};

export { Home };
